
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/yhteys",
      function () {
        return require("private-next-pages/yhteys/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/yhteys"])
      });
    }
  